import "./App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CategoryListing from "./pages/CategoryListing";
import VenueDetail from "./pages/VenueDetail";
import { Toaster } from "./components/ui/toaster";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { PageViewTracker } from "./components/PageViewTracker";
import { CategoriesProvider } from "./context/CategoriesContext";
import { MemberProvider } from "./context/MemberContext";
import { RouteSeo } from "./components/RouteSeo";
const BusinessRegister = lazy(() => import("./pages/BusinessRegister"));
const FirmaPanel = lazy(() => import("./pages/FirmaPanel"));
const AdminPanel = lazy(() => import("./pages/AdminPanel"));
const AdminFirmEdit = lazy(() => import("./pages/AdminFirmEdit"));
const AdminFirmManage = lazy(() => import("./pages/AdminFirmManage"));
const Araclar = lazy(() => import("./pages/Araclar"));
const ArticleDetail = lazy(() => import("./pages/ArticleDetail"));
const PaymentResult = lazy(() => import("./pages/PaymentResult"));
const MemberPanel = lazy(() => import("./pages/MemberPanel"));
const InvitationView = lazy(() => import("./pages/InvitationView"));

const PageFallback = () => <div className="min-h-screen bg-[#FBF5F0]" />;

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <MemberProvider>
          <CategoriesProvider>
          <PageViewTracker />
          <RouteSeo />
          <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kategori/:slug" element={<CategoryListing />} />
            <Route path="/araclar" element={<Araclar />} />
            <Route path="/rehber/:slug" element={<ArticleDetail />} />
            <Route path="/mekan/:slug" element={<VenueDetail />} />
            <Route path="/firma-kayit" element={<BusinessRegister />} />
            <Route path="/firma-panel" element={<FirmaPanel />} />
            <Route path="/uyelik" element={<MemberPanel />} />
            <Route path="/davetiye/:id" element={<InvitationView />} />
            <Route path="/patron" element={<AdminPanel />} />
            <Route path="/patron/firma/:id" element={<AdminFirmManage />} />
            <Route path="/patron/firma/:id/eski" element={<AdminFirmEdit />} />
            <Route path="/odeme/basarili" element={<PaymentResult success={true} />} />
            <Route path="/odeme/basarisiz" element={<PaymentResult success={false} />} />
            <Route path="/:categorySlug/:citySlug/:slug" element={<VenueDetail />} />
            <Route path="/:categorySlug/:citySlug" element={<CategoryListing />} />
          </Routes>
          </Suspense>
          </CategoriesProvider>
          </MemberProvider>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
